import {
  Editor,
  type EditorProps,
  type Monaco,
  type OnMount,
} from "@monaco-editor/react";
import { type editor } from "monaco-editor";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "react-admin";

export const CodeEditor = (props: EditorProps) => {
  const editorRef = useRef<editor.IStandaloneCodeEditor | null>(null);
  const monacoInstanceRef = useRef<Monaco | null>(null);
  const [isMounted, setIsMounted] = useState(false);
  const [theme] = useTheme();

  const handleEditorDidMount: OnMount = (editor, monacoInstance) => {
    editorRef.current = editor;
    monacoInstanceRef.current = monacoInstance;

    props.onMount?.(editor, monacoInstance);
    setIsMounted(true);
  };

  useEffect(() => {
    if (!isMounted) {
      return;
    }

    monacoInstanceRef.current?.editor.setTheme(
      theme === "dark" ? "vs-dark" : "vs",
    );
  }, [isMounted, theme]);

  return <Editor onMount={handleEditorDidMount} {...props} />;
};
